import React, { useState } from "react";
import DoorlocList from "./DoorLocList.jsx";
import ViewDoorloc from "./ViewDoorLoc";
import { fetchDoorlocById } from "../../services/doorloc/doorloc";

export default function DoorlocManagement() {
  const [isCreating, setIsCreating] = useState(false);
  const [activeRecord, setActiveRecord] = useState(null);

  const onlyFormVisible = isCreating || !!activeRecord;

  const closeForm = () => {
    setIsCreating(false);
    setActiveRecord(null); 
  };

  return (
    <div className="card shadow-lg main-card">
      <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
        <h4 className="mb-0 h6 fw-semibold">
          {!onlyFormVisible
            ? "Door Locations"
            : isCreating
            ? "Create Door Location"
            : "View Door Location"}
        </h4>
      </div>

      {onlyFormVisible && (
        <nav aria-label="breadcrumb" className="px-3 py-2 border-bottom bg-light">
          <ol
            className="breadcrumb mb-0 align-items-center"
            style={{ "--bs-breadcrumb-divider": "'/'" }}
          >
            <li className="breadcrumb-item">
              <button
                type="button"
                className="btn btn-link p-0 text-decoration-none text-muted"
                onClick={closeForm}
              >
                Door Locations
              </button>
            </li>
            <li
              className="breadcrumb-item active fw-semibold text-primary"
              aria-current="page"
            >
              {isCreating ? "Create Door Location" : "View Door Location"}
            </li>
          </ol>
        </nav>
      )}

      <div className="card-body">
        {!onlyFormVisible ? (
          <DoorlocList
            onCreateClick={() => setIsCreating(true)}
            onView={async (id) => {
              try {
                const apiData = await fetchDoorlocById(id);
                setActiveRecord({
                  mode: "view",
                  data: apiData,
                });
              } catch (err) {
                console.error("Failed to fetch doorloc by id", err);
              }
            }}
          />
        ) : (
          <ViewDoorloc
            initialValues={activeRecord?.data || {}}
            onCancel={closeForm}
          />
        )}
      </div>
    </div>
  );
}